import React from 'react';

import {FullSection, Typography, Box, Stack} from 'views/components';
import {Translate} from 'views/module';

import Discover from 'views/scenes/product/util/Discover';
import SignupTop from 'views/scenes/product/util/SignupTop';

const Introduction = () => {
  return (
    <Box
    >
      <FullSection
        background='color.white'
        style={{
          py: {xl: 4, md: 2, xs: 1},
        }}
      >
        <Discover activeIcons={{PULSE: true}} />
      </FullSection>
      <FullSection
        style={{
          background: 'linear-gradient(180deg, #FFF 0%, #F6F8FF 100%);',
          pt: {xl: 4, md: 2, xs: 1},
          pb: {md: 4, xs: 10},
          minHeight: {xl: '700px', xs: null},
        }}
      >
        <Box
          sx={{
            mx: {md: '90px', xs: '16px'},
            px: {md: '64px', xs: '0px'},
            py: {xs: 2, md: 1, xs: 1},
            backdropFilter: 'blur(2px)',
            backgroundColor: `rgb(255, 255, 255, 0.5)`,
            borderRadius: '20px',
          }}
        >
          <Stack direction={{md: 'row', xs: 'column'}} >
            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                sx={{
                  width: {lg: '680px', md: '400px', xs: '90vw'},
                }}
              >
                <Typography
                  variant='h3'
                  sx={{
                    textAlign: 'left',
                    color: 'primary.main',
                  }}
                >
                  <Translate expression='pulse.Body' />
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    textAlign: 'left',
                    color: 'primary.main',
                    pt: '24px',
                  }}
                >
                  <Translate expression='pulse.SubBody' />
                </Typography>
              </Box>
              <Box>
                <SignupTop />
              </Box>
            </Box>
            <Box
              sx={{
                maxWidth: {md: '294px', xs: '100vw'},
                maxHeight: {md: '294px', xs: '100vw'},
                m: 'auto',
                display: {md: 'block', xs: 'none'},
              }}
            >
              <img
                style={{
                  height: '100%',
                  width: '100%',
                }}
                src='\images\product_group\ProductGroup.svg'
              />
            </Box>
          </Stack>
        </Box>
      </FullSection>
    </Box>
  );
};

export default Introduction;
